:host {
  animation-duration: var(--aha-fade-out--duration);
  animation-delay: var(--aha-fade-out--delay);
  animation-timing-function: var(--aha-fade-out--timing-function);
  animation-fill-mode: forwards;
  animation-name: fade-out;
}
:host([paused]) {
  animation-play-state: paused;
}
:host(:not[paused]) {
  animation-play-state: running;
}

@keyframes fade-out {
  from {
    opacity: 1;
    visibility: visible;
  }

  to {
    opacity: 0;
    visibility: hidden;
  }
}
